import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Grid, Menu, Segment } from 'semantic-ui-react';
import { setEmployeeMenuItem } from '../../state/business/actions';
import EmployeeSlots from './EmployeeSlots';
import EmployeeLogs from './EmployeeLogs';
import EmployeeActions from './EmployeeActions';
import styles from './BusinessDetailSections.module.css';

const EmployeeSection = props => {
  const { employeeMenuItem, dispatch } = props;

  const handleEmployeeItemClick = (e, { name }) => {
    dispatch(setEmployeeMenuItem(name));
  };

  return (
    <div className={styles.section}>
      <Grid>
        <Grid.Column stretched width={3}>
          <Menu fluid vertical tabular>
            <Menu.Item
              name="slots"
              active={employeeMenuItem === 'slots'}
              onClick={handleEmployeeItemClick}
            />
            <Menu.Item
              name="actions"
              active={employeeMenuItem === 'actions'}
              onClick={handleEmployeeItemClick}
            />
            <Menu.Item
              name="logs"
              active={employeeMenuItem === 'logs'}
              onClick={handleEmployeeItemClick}
            />
          </Menu>
        </Grid.Column>
        <Grid.Column stretched width={13}>
          <div className={styles['item-component']}>
            <Segment>
              {employeeMenuItem === 'slots' ? <EmployeeSlots /> : <></>}
              {employeeMenuItem === 'actions' ? <EmployeeActions /> : <></>}
              {employeeMenuItem === 'logs' ? <EmployeeLogs /> : <></>}
            </Segment>
          </div>
        </Grid.Column>
      </Grid>
    </div>
  );
};

const mapStateToProps = ({ business }) => ({
  employeeMenuItem: business.employeeMenuItem,
});

EmployeeSection.propTypes = {
  dispatch: PropTypes.func.isRequired,
  employeeMenuItem: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(EmployeeSection);
